"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var luxon_1 = require("luxon");
var React = __importStar(require("react"));
var utils_1 = require("../../utils");
var BatchCard_1 = __importDefault(require("../BatchCard"));
var Card_1 = __importDefault(require("../Card"));
var Column_1 = __importDefault(require("../Column"));
var PartnerCard_1 = __importDefault(require("../PartnerCard"));
var PassFailChip_1 = __importDefault(require("../PassFailChip"));
var Row_1 = __importDefault(require("../Row"));
var SampleInfoCard_1 = __importDefault(require("../SampleInfoCard"));
var TestedNotTestedChip_1 = __importDefault(require("../TestedNotTestedChip"));
var R = __importStar(require("ramda"));
var ChemicalResidue_1 = require("../cards/ChemicalResidue");
var StandardCalloutsSection_1 = __importDefault(require("../StandardCalloutsSection"));
var EdibleCalloutsSection_1 = __importDefault(require("../EdibleCalloutsSection"));
var cards_1 = require("../cards");
var D8ThcCard_1 = __importDefault(require("../D8ThcCard"));
var D9ThcCard_1 = __importDefault(require("../D9ThcCard"));
var style = renderer_1.StyleSheet.create({
    text: {
        fontFamily: "Quicksand",
    },
    productName: {
        fontSize: 24,
        fontWeight: 700,
    },
    overallBatchResultText: {
        fontSize: 12,
        fontWeight: 700,
    },
    column: {
        margin: 2.15,
    },
});
var FirstPage = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var sample = _a.sample;
    var results = utils_1.resultsMapFactory(sample);
    var passFailMap = {
        cannabinoids: utils_1.determinePanelPassFail({
            panelResult: results.cannabinoids,
            stateReportingRegulations: sample.complianceType.stateReportingRegulations,
            moistureContentPercentage: (_b = utils_1.getMoistureContent(sample)) !== null && _b !== void 0 ? _b : 0,
            density: utils_1.getDensity(sample),
            amountPerServing: sample.accession.amountPerServing,
            amountPerPackage: sample.accession.amountPerPackage,
            shouldCorrectForMoisture: true,
        }),
        heavyMetals: utils_1.determinePanelPassFail({
            panelResult: results.heavyMetals,
            stateReportingRegulations: sample.complianceType.stateReportingRegulations,
            moistureContentPercentage: (_c = utils_1.getMoistureContent(sample)) !== null && _c !== void 0 ? _c : 0,
            density: utils_1.getDensity(sample),
        }),
        residualSolvents: utils_1.determinePanelPassFail({
            panelResult: !!results.residualSolvents
                ? __assign(__assign({}, results.residualSolvents), { results: __assign(__assign({}, results.residualSolvents.results), { components: __spreadArrays(results.residualSolvents.results.components, [
                            cards_1.deriveTotalXylenes({
                                components: results.residualSolvents.results.components,
                                parameters: results.residualSolvents.instrumentUsed
                                    .instrumentParameters,
                            }),
                        ]) }) }) : undefined,
            stateReportingRegulations: sample.complianceType.stateReportingRegulations,
            moistureContentPercentage: (_d = utils_1.getMoistureContent(sample)) !== null && _d !== void 0 ? _d : 0,
            density: utils_1.getDensity(sample),
        }),
        microbial: utils_1.areAllValuesPass((_f = (_e = results.microbial) === null || _e === void 0 ? void 0 : _e.results) !== null && _f !== void 0 ? _f : {})
            ? "PASS"
            : "FAIL",
        chemicalResidue: utils_1.determinePanelPassFail({
            panelResult: !!results.chemicalResidue
                ? __assign(__assign({}, results.chemicalResidue), { results: __assign(__assign({}, results.chemicalResidue.results), { components: __spreadArrays(results.chemicalResidue.results.components, [
                            cards_1.deriveTotalAflatoxinsResult({
                                components: results.chemicalResidue.results.components,
                                parameters: results.chemicalResidue.instrumentUsed.instrumentParameters,
                            }),
                            cards_1.deriveSpinosadResult({
                                components: results.chemicalResidue.results.components,
                                parameters: results.chemicalResidue.instrumentUsed.instrumentParameters,
                            }),
                            cards_1.derivePyrethrinResult({
                                components: results.chemicalResidue.results.components,
                                parameters: results.chemicalResidue.instrumentUsed.instrumentParameters,
                            }),
                        ]) }) }) : undefined,
            stateReportingRegulations: sample.complianceType.stateReportingRegulations,
            analyteProp: "analyte",
            moistureContentPercentage: (_g = utils_1.getMoistureContent(sample)) !== null && _g !== void 0 ? _g : 0,
            density: utils_1.getDensity(sample),
        }),
        foreignMaterial: (_j = (_h = results.foreignMaterial) === null || _h === void 0 ? void 0 : _h.results.inspectionResult) !== null && _j !== void 0 ? _j : "PASS",
        waterActivity: utils_1.determinePanelPassFail({
            panelResult: results.waterActivity,
            stateReportingRegulations: sample.complianceType.stateReportingRegulations,
            moistureContentPercentage: (_k = utils_1.getMoistureContent(sample)) !== null && _k !== void 0 ? _k : 0,
            density: utils_1.getDensity(sample),
        }),
    };
    return (React.createElement(renderer_1.View, null,
        React.createElement(Row_1.default, { style: { justifyContent: "center", marginBottom: 5 } },
            React.createElement(renderer_1.Text, { style: [style.text, style.productName] }, sample.productName)),
        utils_1.shouldDisplayPassFail(sample) && (React.createElement(Row_1.default, { style: { justifyContent: "center", marginBottom: 5 } },
            React.createElement(renderer_1.Text, { style: [
                    style.text,
                    style.overallBatchResultText,
                    { marginRight: 15 },
                ] }, "Overall Batch Result"),
            React.createElement(PassFailChip_1.default, { result: utils_1.areAllValuesPass(passFailMap) ? "PASS" : "FAIL" }))),
        React.createElement(Row_1.default, null,
            React.createElement(Column_1.default, { style: style.column },
                React.createElement(Row_1.default, { style: { width: 200, height: 155 } },
                    React.createElement(Card_1.default, { style: { padding: 0, flexGrow: 1 } },
                        React.createElement(renderer_1.Image, { style: { objectFit: "contain" }, src: sample.photo.url })))),
            React.createElement(Column_1.default, { style: style.column },
                React.createElement(Row_1.default, null,
                    sample.reportFirstPage === "Standard" && results.cannabinoids && (React.createElement(StandardCalloutsSection_1.default, { cannabinoidsPanelResult: results.cannabinoids, terpenesPanelResult: results.terpenes, moistureContentPercentage: utils_1.getMoistureContent(sample), density: utils_1.getDensity(sample), waterActivity: utils_1.getWaterActivity(sample), parameters: (_l = results.cannabinoids) === null || _l === void 0 ? void 0 : _l.instrumentUsed.instrumentParameters })),
                    sample.reportFirstPage === "Edible" && results.cannabinoids && (React.createElement(EdibleCalloutsSection_1.default, { cannabinoidsPanelResult: results.cannabinoids, moistureContentPercentage: utils_1.getMoistureContent(sample), density: utils_1.getDensity(sample), amountPerServing: sample.accession.amountPerServing, amountPerPackage: sample.accession.amountPerPackage, isSolid: utils_1.isSampleSolid(sample), parameters: (_m = results.cannabinoids) === null || _m === void 0 ? void 0 : _m.instrumentUsed.instrumentParameters })),
                    sample.reportFirstPage === "Δ8" && results.cannabinoids && (React.createElement(StandardCalloutsSection_1.default, { cannabinoidsPanelResult: results.cannabinoids, terpenesPanelResult: results.terpenes, moistureContentPercentage: utils_1.getMoistureContent(sample), density: utils_1.getDensity(sample), waterActivity: utils_1.getWaterActivity(sample), parameters: (_o = results.cannabinoids) === null || _o === void 0 ? void 0 : _o.instrumentUsed.instrumentParameters, ThcCardComponent: D8ThcCard_1.default })),
                    sample.reportFirstPage === "Δ9" && results.cannabinoids && (React.createElement(StandardCalloutsSection_1.default, { cannabinoidsPanelResult: results.cannabinoids, terpenesPanelResult: results.terpenes, moistureContentPercentage: utils_1.getMoistureContent(sample), density: utils_1.getDensity(sample), waterActivity: utils_1.getWaterActivity(sample), parameters: (_p = results.cannabinoids) === null || _p === void 0 ? void 0 : _p.instrumentUsed.instrumentParameters, ThcCardComponent: D9ThcCard_1.default }))))),
        React.createElement(Row_1.default, null,
            React.createElement(Column_1.default, { style: style.column },
                React.createElement(Row_1.default, null,
                    React.createElement(BatchCard_1.default, { lotOrBatchNumber: sample.lotOrBatchNumber, sourceUID: ((_q = sample.metrcPackage) === null || _q === void 0 ? void 0 : _q.sourcePackageLabels) || "N/A", packageUID: ((_r = sample.metrcPackage) === null || _r === void 0 ? void 0 : _r.packageLabel) || "N/A" })),
                sample.distributor && (React.createElement(Row_1.default, null,
                    React.createElement(PartnerCard_1.default, { partner: sample.distributor, partnerType: "Distributor" }))),
                sample.producer && (React.createElement(Row_1.default, null,
                    React.createElement(PartnerCard_1.default, { partner: sample.producer, partnerType: "Producer" }))),
                React.createElement(Row_1.default, null,
                    React.createElement(SampleInfoCard_1.default, { sample: sample }))),
            React.createElement(Column_1.default, { style: __assign(__assign({}, style.column), { flexGrow: 1, paddingRight: 10 }) },
                React.createElement(Row_1.default, { style: {
                        alignItems: "center",
                        height: 35,
                        paddingLeft: 15,
                    } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Cannabinoids")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.cannabinoids,
                            result: passFailMap.cannabinoids,
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Terpenes")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: false,
                            wasTested: !!results.terpenes,
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Heavy Metals")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.heavyMetals,
                            result: passFailMap.heavyMetals,
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Residual Solvents")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.residualSolvents,
                            result: passFailMap.residualSolvents,
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Microbials")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.microbial,
                            result: passFailMap.microbial,
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Chemical Residues")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.chemicalResidue,
                            result: results.chemicalResidue
                                ? utils_1.determinePanelPassFail({
                                    panelResult: !!results.chemicalResidue
                                        ? __assign(__assign({}, results.chemicalResidue), { results: __assign(__assign({}, results.chemicalResidue.results), { components: __spreadArrays(results.chemicalResidue.results.components, [
                                                    cards_1.deriveSpinosadResult({
                                                        components: results.chemicalResidue.results
                                                            .components,
                                                        parameters: results.chemicalResidue.instrumentUsed
                                                            .instrumentParameters,
                                                    }),
                                                    cards_1.derivePyrethrinResult({
                                                        components: results.chemicalResidue.results
                                                            .components,
                                                        parameters: results.chemicalResidue.instrumentUsed
                                                            .instrumentParameters,
                                                    }),
                                                ]) }) }) : undefined,
                                    stateReportingRegulations: sample.complianceType.stateReportingRegulations,
                                    filterComponentFunc: R.pipe(R.prop("analyte"), ChemicalResidue_1.isMycotoxin, R.not),
                                    analyteProp: "analyte",
                                    moistureContentPercentage: (_s = utils_1.getMoistureContent(sample)) !== null && _s !== void 0 ? _s : 0,
                                    density: utils_1.getDensity(sample),
                                })
                                : "FAIL",
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Mycotoxins")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.chemicalResidue,
                            result: results.chemicalResidue
                                ? utils_1.determinePanelPassFail({
                                    panelResult: !!results.chemicalResidue
                                        ? __assign(__assign({}, results.chemicalResidue), { results: __assign(__assign({}, results.chemicalResidue.results), { components: __spreadArrays(results.chemicalResidue.results.components, [
                                                    cards_1.deriveTotalAflatoxinsResult({
                                                        components: results.chemicalResidue.results
                                                            .components,
                                                        parameters: results.chemicalResidue.instrumentUsed
                                                            .instrumentParameters,
                                                    }),
                                                ]) }) }) : undefined,
                                    stateReportingRegulations: sample.complianceType.stateReportingRegulations,
                                    filterComponentFunc: R.pipe(R.prop("analyte"), ChemicalResidue_1.isMycotoxin),
                                    analyteProp: "analyte",
                                    moistureContentPercentage: (_t = utils_1.getMoistureContent(sample)) !== null && _t !== void 0 ? _t : 0,
                                    density: utils_1.getDensity(sample),
                                })
                                : "FAIL",
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Foreign Materials")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.foreignMaterial,
                            result: passFailMap.foreignMaterial,
                        })))),
                React.createElement(Row_1.default, { style: { alignItems: "center", height: 35, paddingLeft: 15 } },
                    React.createElement(Column_1.default, { style: { flexGrow: 1 } },
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand" } }, "Water Activity")),
                    React.createElement(Column_1.default, null,
                        React.createElement(Row_1.default, { style: {
                                justifyContent: "center",
                                alignItems: "center",
                                height: 35,
                            } }, displayChip({
                            shouldDisplayPassFail: utils_1.shouldDisplayPassFail(sample),
                            wasTested: !!results.waterActivity,
                            result: passFailMap.waterActivity,
                        })))))),
        React.createElement(Row_1.default, null,
            React.createElement(Column_1.default, { style: { marginRight: 20 } },
                React.createElement(Card_1.default, { style: { width: 200, alignItems: "center" } },
                    React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 8 } }, "Data Review"),
                    !!sample.sampleApproval ? (React.createElement(React.Fragment, null,
                        React.createElement(renderer_1.View, { style: {
                                borderBottom: 1,
                                borderColor: "#e1e1e1",
                                height: 30,
                                width: "100%",
                                marginHorizontal: 30,
                                marginBottom: 5,
                            } }),
                        React.createElement(renderer_1.View, { style: {
                                maxWidth: 100,
                                height: 50,
                                position: "absolute",
                                top: 22,
                            } },
                            React.createElement(renderer_1.Image, { src: (_v = (_u = sample.sampleApproval.approvedBy.signatureFile) === null || _u === void 0 ? void 0 : _u.url) !== null && _v !== void 0 ? _v : "" })),
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 7 } },
                            sample.sampleApproval.approvedBy.firstName,
                            " ",
                            sample.sampleApproval.approvedBy.lastName),
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 7 } }, sample.sampleApproval.approvedBy.title),
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 7 } }, luxon_1.DateTime.fromISO(sample.sampleApproval.approvedAt).toLocaleString(luxon_1.DateTime.DATE_SHORT)))) : null)),
            React.createElement(Column_1.default, null,
                React.createElement(Card_1.default, { style: { width: 200, alignItems: "center" } },
                    React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 8 } }, "Quality Review"),
                    !!sample.sampleQAEntry && (React.createElement(React.Fragment, null,
                        React.createElement(renderer_1.View, { style: {
                                borderBottom: 1,
                                borderColor: "#e1e1e1",
                                height: 30,
                                width: "100%",
                                marginHorizontal: 30,
                                marginBottom: 5,
                            } }),
                        React.createElement(renderer_1.View, { style: {
                                maxWidth: 100,
                                height: 50,
                                position: "absolute",
                                top: 20,
                            } },
                            React.createElement(renderer_1.Image, { src: (_x = (_w = sample.sampleQAEntry.verifiedBy.signatureFile) === null || _w === void 0 ? void 0 : _w.url) !== null && _x !== void 0 ? _x : "" })),
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 7 } },
                            sample.sampleQAEntry.verifiedBy.firstName,
                            " ",
                            sample.sampleQAEntry.verifiedBy.lastName),
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 7 } }, sample.sampleQAEntry.verifiedBy.title),
                        React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 7 } }, luxon_1.DateTime.fromISO(sample.sampleQAEntry.verifiedAt).toLocaleString(luxon_1.DateTime.DATE_SHORT)))))))));
};
var displayChip = function (_a) {
    var shouldDisplayPassFail = _a.shouldDisplayPassFail, wasTested = _a.wasTested, _b = _a.result, result = _b === void 0 ? "FAIL" : _b;
    return shouldDisplayPassFail && wasTested ? (React.createElement(PassFailChip_1.default, { result: result })) : (React.createElement(TestedNotTestedChip_1.default, { result: wasTested ? "TESTED" : "NOT TESTED" }));
};
exports.default = FirstPage;
//# sourceMappingURL=index.js.map